import * as React from 'react';

export function TargetAudience() {
  return (
    <section className="ong-audience">
      <style>{`
        .ong-audience {
          padding: 72px 24px;
          background: #fff;
        }
        .ong-audience-inner {
          max-width: 800px;
          margin: 0 auto;
        }
        .ong-audience h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 36px;
          text-align: center;
        }
        .ong-audience-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 40px;
        }
        .ong-audience-col h3 {
          font-size: 16px;
          font-weight: 700;
          color: #1EAA25;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin: 0 0 16px;
        }
        .ong-audience-col ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        .ong-audience-col li {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 0;
          font-size: 16px;
          color: #333;
          border-bottom: 1px solid #f0f0f0;
        }
        .ong-audience-col li:last-child {
          border-bottom: none;
        }
        .ong-audience-col li i {
          color: #1EAA25;
          font-size: 14px;
          flex-shrink: 0;
          width: 20px;
          text-align: center;
        }
        @media (max-width: 640px) {
          .ong-audience-grid {
            grid-template-columns: 1fr;
            gap: 32px;
          }
          .ong-audience h2 {
            font-size: 24px;
          }
        }
      `}</style>
      <div className="ong-audience-inner">
        <h2>Organizaciones que ya confían en nosotros</h2>
        <div className="ong-audience-grid">
          <div className="ong-audience-col">
            <h3>Trabajamos con</h3>
            <ul>
              <li><i className="fa fa-hands-helping" /> Comedores comunitarios</li>
              <li><i className="fa fa-home" /> Hogares de niños y adolescentes</li>
              <li><i className="fa fa-heart" /> Fundaciones</li>
              <li><i className="fa fa-sun" /> Centros de día</li>
              <li><i className="fa fa-users" /> Asociaciones civiles</li>
            </ul>
          </div>
          <div className="ong-audience-col">
            <h3>Que buscan</h3>
            <ul>
              <li><i className="fa fa-check" /> Calidad al mejor precio</li>
              <li><i className="fa fa-check" /> Facturación para rendiciones</li>
              <li><i className="fa fa-check" /> Entrega puntual</li>
              <li><i className="fa fa-check" /> Precios predecibles</li>
              <li><i className="fa fa-check" /> Relación de confianza</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
